import React from 'react';
import clsx from 'clsx';
import { connect } from 'react-redux';
import { IState } from 'services/root-reducer';
import { getOperation, getOperationData } from 'selectors';
import { CategoryItem } from './category-item';
import { categoriesConfig, isCategoryAvailable } from '../categories-config';
import { CategoryBanners } from '../category-banners';
import './style.scss';

interface ICategoryPanelProps {
    category: string,
    allContainers: IState['operations']['CONTAINERS']['data'];
    panelClassname?: string;
    hideHints?: boolean;
}

const mapStateToProps = (state: IState) => ({
    initialize: getOperation(state, 'APP_INITIALIZE'),
    allContainers: getOperationData(state, 'CONTAINERS')
});

const CategoryPanelComponent: React.FC<ICategoryPanelProps> = (props): JSX.Element => {
    const {
        category,
        allContainers,
        panelClassname,
        hideHints = false
    } = props;

    if (!isCategoryAvailable(category)) return null;

    let rootsWithList = Object.keys(categoriesConfig).reduce((acc, key) => (
        [ ...acc, ...categoriesConfig[key].objectsList ]
    ), []);
    if (rootsWithList.indexOf('gen_plans') !== -1) {
        rootsWithList.splice(rootsWithList.indexOf('gen_plans'), 1);
    }

    const parentContainer = allContainers.find(cont => cont.code === category);

    let containers;
    if (categoriesConfig[category] && categoriesConfig[category].containers.length !== 0) {
        const confContainers = categoriesConfig[category].containers;
        const unSorted = allContainers.filter(cont =>
            confContainers.includes(cont.code) || confContainers.includes(cont.id));
        containers = confContainers.map((code_or_id) => (
            unSorted.find(cont => (cont.code === code_or_id || cont.id === code_or_id))
        )).filter(c => !!c);
    } else {
        containers = allContainers.filter(cont => cont.parent_id === parentContainer?.id);
    }
    let lightDivider = 0;

    const renderCategories = containers.map((cont) => {
        lightDivider += !rootsWithList.includes(cont.code) ? 1 : 0;
        return (
            <div key={cont.id}>
                <div
                    className={clsx(
                        'category-panel__divider', lightDivider > 1 && 'light'
                    )}
                />
                <CategoryItem
                    hideHints={hideHints}
                    container={cont}
                    category={category}
                />
            </div>
        );
    });

    const banner = <CategoryBanners category={category} lightDivider={lightDivider} key="banner" />;
    renderCategories.push(banner);

    return (
        <div className={clsx('category-panel', panelClassname)}>
            {renderCategories}
        </div>
    );
};

export const CategoryPanel = connect(mapStateToProps)(CategoryPanelComponent);
